import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import { Button } from "../../common/Button";
import { Close, Done, VideocamOutlined, FilePresent } from "@mui/icons-material";
import { eventType } from "./Constants";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { getPatientInfo, getSingleUser } from "../../api/Individual";
import { failed, success } from "../../common/Toastify";
import { AttachementModal } from "./AttachementModal";
import { Tooltip } from "@mui/material";
import Video from "../../../assets/images/Video.svg";
import Audio from "../../../assets/images/Audio.svg";
import { axios } from "../../../lib/axios";
import { FullPageSpinner } from "../../common/Spinner/FullPageSpinner";
import { ViewDate, safeAgeString } from "../../../utils/DateSupport";
import { useSelector } from "react-redux";
import Fade from 'react-bootstrap/Fade';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ConfirmationModal from "../../common/ConfirmationModal";
import { useEncounterQuestionnaireResponseQuery } from "../../../hooks/ReactQueryHooks/useQuestionnaireResponseQuery";

export function ViewAppointmentModal({ modalShow, handleShow, handleConnect, handleCall, handleUpdateRequest, appointmentsList, isProviderAppointment=false, setScheduleModal=false, url, readOnly=false }) {
    const [data, setData] = useState("");
    const [questionnaireResponse, setQuestionnaireResponse] = useState("");
    const [patient, setPatient] = useState("");
    const [attachmentUrl, setAttachmentUrl] = useState('');
    const [showAttachmentModal, setShowAttachmentModal] = useState(false);
    const [loading, setLoading] = useState(false)
    const [documentData, setDocumentData] = useState({});
    const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
    const practitionerId = useSelector((state) => state?.auth?.user?.["custom:practitioner_id"])
    const patientHCN = patient?.patient_identifier?.find((ele) => ele?.type === "HCN")?.value || patient?.identifier?.find((ele) => ele?.type === "HCN")?.value;
    const [openStates, setOpenStates] = useState({});
    const [confirmmodalShow, setconfirmmodalShow] = useState(false);
    const [questionnaireState, setQuestionnaireState] = useState(null);

    const handleToggle = (questionKey) => {
    setOpenStates((prevOpenStates) => ({
        ...prevOpenStates,
        [questionKey]: !prevOpenStates[questionKey],
    }));
    };

    const {
        data: questionnaireResponses,     
        isLoading,
        isError,
        refetch,
    } = useEncounterQuestionnaireResponseQuery({
        encounterId: data?.encounterId,
        onSuccess: setQuestionnaireState,
        enabled: Boolean(data?.encounterId && modalShow),
    });


    useEffect(() => {
        if (modalShow && data?.encounterId) {
        refetch();
        }
    }, [modalShow, data?.encounterId, refetch]);




    useEffect(() => {
        setData(appointmentsList?.filter(data => data.id === modalShow)[0])
        if(data){

            getPatientInfo(data?.patientId).then((res) => {
                if (res?.status === true) {
                    setPatient(res?.result)
                }
            }).catch((res) => {
                failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
            });
            //getSingleUser({id : data.patientId, type: 'Patient', userOrgId: adminOrgs?.[0]?.id})
            //.then((res) => setPatient(res.data))
            //.catch((res) => {
            //    failed(res?.response?.data?.message || res?.response?.data?.error || res.message);
            //});
        }
    }, [modalShow, data])

    const handleScheduleModal = (appointmentData) => {
        setScheduleModal(appointmentData)
        handleShow()
    }

    var a = moment().format("X");
    var b = moment(data?.requestedPeriod?.[0]?.start?.replace("Z", "")).format("X");
    //const isTimeAvailable = parseInt(a) > parseInt(b);

    const handleShowFile = async(data) => {
        setLoading(true)
        let response
        try {
            response = await axios.get(`/appointment/${modalShow}`);
            if(response?.status){
                setLoading(false)
                const document = response?.data?.document?.find((obj)=> obj?.key == data?.key)
                setAttachmentUrl(data?.url)
                setDocumentData(document)
                setShowAttachmentModal(true)
            }
        } catch (error) {
           setLoading(false)
           failed(response?.message)
        }
    }

    const handleCancelRequest = (data) => {
        setconfirmmodalShow(true);
      }; 
    const handleConfirm = async (data) => {
        await handleUpdateRequest(data, "cancelled");
    }; 
    const handleCancel = () => {
        setconfirmmodalShow(false);
    };

    return (
        <>
            {loading ? <FullPageSpinner /> : null}
            {showAttachmentModal ? <AttachementModal documentData={documentData} modalShow={showAttachmentModal} url={attachmentUrl} handleShow={() => setShowAttachmentModal(false)} /> : null}
            <Modal
                backdropClassName
                backdrop={'static'}
                show={modalShow} onHide={handleShow}
                aria-labelledby="contained-modal-title-vcenter"
                centered className="custom-dialog appointment-custom-modal">
                <Modal.Header closeButton className="border-0">
                    <span className="header-text">Patient:</span>&nbsp;&nbsp;
                    <Modal.Title id="contained-modal-title-vcenter" style={{ textTransform: "capitalize" }}>
                        {data?.participant?.filter((data) => data?.actor?.type === "Patient")?.[0]?.actor?.display}
                    </Modal.Title>&nbsp;&nbsp;&nbsp;&nbsp;
                    {/* Appointment type- Accepted */}
                    {(data?.status === "booked" && !isProviderAppointment) && (
                       <div className="action-wrap">
                            {/* <Tooltip title={data?.questionnaireResponse?.preferredChannel}>
                                {data?.questionnaireResponse?.preferredChannel === 'phone' || data?.questionnaireResponse?.preferredChannel === 'Phone' ? ( 
                                    <img src={Audio} alt="Audio Channel" /> 
                                  ) : (
                                    <img src={Video} alt="Video Channel" /> 
                                )}
                            </Tooltip> */}
                            <Tooltip title={data?.intakeQuestions?.preferredChannel}>
                                {data?.intakeQuestions?.preferredChannel === 'phone' || data?.intakeQuestions?.preferredChannel === 'Phone' ? ( 
                                    <img src={Audio} alt="Audio Channel" /> 
                                  ) : (
                                    <img src={Video} alt="Video Channel" /> 
                                )}
                            </Tooltip>
                       </div>
                    )}
                    {/* Appointment type- Pending */}
                    {data?.status === "proposed"  && (
                    //    <div className="action-wrap">
                    //         <Tooltip title={data?.questionnaireResponse?.preferredChannel}>
                    //             {data?.questionnaireResponse?.preferredChannel === 'phone' || data?.questionnaireResponse?.preferredChannel === 'Phone' ? ( 
                    //                 <img src={Audio} alt="Audio Channel" /> 
                    //               ) : (
                    //                 <img src={Video} alt="Video Channel" /> 
                    //             )}
                    //         </Tooltip>
                    //    </div>
                    <div className="action-wrap">
                            <Tooltip title={data?.intakeQuestions?.preferredChannel}>
                                {data?.intakeQuestions?.preferredChannel === 'phone' || data?.intakeQuestions?.preferredChannel === 'Phone' ? ( 
                                    <img src={Audio} alt="Audio Channel" /> 
                                  ) : (
                                    <img src={Video} alt="Video Channel" /> 
                                )}
                            </Tooltip>
                       </div>
                    )}
                    {/* Appointment type- Rejected */}
                    {data?.status === "cancelled"  && (
                       <div className="action-wrap">
                            {/* <Tooltip title={data?.questionnaireResponse?.preferredChannel}>
                                {data?.questionnaireResponse?.preferredChannel === 'phone' || data?.questionnaireResponse?.preferredChannel === 'Phone' ? ( 
                                    <img src={Audio} alt="Audio Channel" /> 
                                  ) : (
                                    <img src={Video} alt="Video Channel" /> 
                                )}
                            </Tooltip> */}
                            <Tooltip title={data?.intakeQuestions?.preferredChannel}>
                                {data?.intakeQuestions?.preferredChannel === 'phone' || data?.intakeQuestions?.preferredChannel === 'Phone' ? ( 
                                    <img src={Audio} alt="Audio Channel" /> 
                                  ) : (
                                    <img src={Video} alt="Video Channel" /> 
                                )}
                            </Tooltip>
                       </div>
                    )}
                    {/* Appointment type- Completed */}
                    {data?.status === "completed"  && (
                    //    <div className="action-wrap">
                    //         <Tooltip title={data?.questionnaireResponse?.preferredChannel}>
                    //             {data?.questionnaireResponse?.preferredChannel === 'phone' || data?.questionnaireResponse?.preferredChannel === 'Phone' ? ( 
                    //                 <img src={Audio} alt="Audio Channel" /> 
                    //               ) : (
                    //                 <img src={Video} alt="Video Channel" /> 
                    //             )}
                    //         </Tooltip>
                    //    </div>
                    <div className="action-wrap">
                            <Tooltip title={data?.intakeQuestions?.preferredChannel}>
                                {data?.intakeQuestions?.preferredChannel === 'phone' || data?.intakeQuestions?.preferredChannel === 'Phone' ? ( 
                                    <img src={Audio} alt="Audio Channel" /> 
                                  ) : (
                                    <img src={Video} alt="Video Channel" /> 
                                )}
                            </Tooltip>
                       </div>
                    )}
                    <div style={{ background: eventType?.[data?.status]?.backgroundColor, color: eventType?.[data?.status]?.textColor, borderRadius: "2rem", padding: "0 0.7rem", marginLeft: "clamp(0rem, 3.5vw, 3rem)" }}>{eventType?.[data?.status]?.name}</div>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col> 
                        <b>Appointment Details</b>
                            <div className="col-section">
                                <span className="label-grey">Date:</span>  {`${ViewDate(data?.requestedPeriod?.[0]?.start)}`} | <span className="label-grey">Time:</span>  {`${moment(data?.requestedPeriod?.[0]?.start).format("HH:mm")} - ${moment(data?.requestedPeriod?.[0]?.end).format("HH:mm")}`} <br/>
                                <span className="label-grey">Reason for visit:</span>  {data?.description}<br />
                                <span className="label-grey">Appointment Type:</span> {data?.serviceCategory?.[0]?.coding?.[0]?.display || "-"}<br />
                                <span className="label-grey">Return Telephone Number:</span> {data?.intakeQuestions?.callerNumber} { data?.intakeQuestions?.callerNumberExt && data?.intakeQuestions?.callerNumberExt != "" ? 'ext. ' + data?.intakeQuestions?.callerNumberExt : '' }<br/>
                                <span className="label-grey">Preferred Channel: </span>  <span style={{textTransform: "capitalize"}}>{data?.intakeQuestions?.preferredChannel}</span><br />
                                <span className="label-grey">Attachments:</span>
                                    {data?.document?.length > 0 && data?.document.map((pdfUrl, index) => (<Link onClick={()=> handleShowFile(pdfUrl)}> <FilePresent /> </Link>))}
                                    {data?.document?.url && ( <Link onClick={()=> handleShowFile(data?.document)}><FilePresent/></Link>)} 
                                    {!data?.document?.length > 0 && !data?.document?.url && (<span>-</span>)} <br />
                                
                                    
                            </div> 
                        </Col>
                        <Col>
                        <b>Patient Details</b>
                            <div className="col-section"> 
                                <span className="label-grey">Name: </span> <a href={`/app/patients-details?patientId=${data?.participant?.find(p => p?.actor?.type === "Patient")?.actor?.reference.split('/')[1]}`} style={{color: "#0064a6", textTransform: "capitalize"}} target="_blank" rel="noopener noreferrer"> {data?.participant?.filter((data) => data?.actor?.type === "Patient")?.[0]?.actor?.display}</a> | <span className="label-grey">Gender: </span>  <span style={{textTransform: "capitalize"}}>{patient?.gender}</span><br />
                                <span className="label-grey">DOB: </span>{ViewDate(patient?.birthDate)} | <span className="label-grey">Age: </span>{safeAgeString(patient?.birthDate)}<br />
                                <span className="label-grey">Phone: </span>  {patient?.telecom?.find((ele) => ele?.system === "phone")?.value || ""}<br />
                                <span className="label-grey">Email: </span>  {patient?.telecom?.find((ele) => ele?.system === "email")?.value || ""}<br />
                                <span className="label-grey">HCN: </span> {patientHCN || ""}  
                            </div>
                        </Col> 
                    </Row>  
                    <hr />
                    <Row className="my-3">
                        <Col>
                            <b>Intake Questions</b>
                            <div className="col-section">
                            {isLoading && <FullPageSpinner />}
                            {isError && <p>Couldn’t load questions.</p>}

                            {questionnaireResponses?.[0]?.item?.length > 0 ? (
                                questionnaireResponses[0].item
                                .filter(q => {
                                    if (q?.text?.trim() === "Relationship to Patient") {
                                    const callingQ = questionnaireResponses[0].item.find(
                                        cq => cq.text.trim() === "Calling for yourself?"
                                    );
                                    const calledForSelf = callingQ?.answer.find(a => a.valueBoolean)?.option === "Yes";
                                    return !calledForSelf;
                                    }
                                    return true;
                                })
                            
                                .map(q => (
                                    <div key={q.linkId} style={{ display: "flex", flexDirection: "row" }}>
                                    <strong>{q.text}&nbsp;:&nbsp;&nbsp;</strong>
                                    {q.questionType === "radio" ? (
                                        <div>
                                        {q.answer.find(a => a.valueBoolean === true)?.option ?? "—"}
                                        </div>
                                    ) : (
                                        q.answer.map((ans, i) => (
                                        <div key={i}>
                                            {ans.valueString ?? ans.option ?? "—"}
                                        </div>
                                        ))
                                    )}
                                    </div>
                                ))
                            ) : (
                                <div>No intake response available.</div>
                            )}
                            </div>
                        </Col>
                    </Row>

                    <br/>
                    {!readOnly && (
                    <div className="btn-wrap-block">
                    {(data?.status === "booked" && !isProviderAppointment) 
                    ? <div className="action-wrap" style={{ display: "flex", justifyContent: "space-around"}}>
                            {/* <Button variant="primary" onClick={() => (data?.questionnaireResponse?.preferredChannel === 'phone' || data?.questionnaireResponse?.preferredChannel === 'Phone') ? handleCall(data) : handleConnect(data)} className="success-btn" style={{margin: "0 7px 0 0"}}>Connect</Button> */}
                            {(data?.practitionerId === practitionerId) && <Button variant="primary" onClick={() => (data?.intakeQuestions?.preferredChannel === 'phone' || data?.intakeQuestions?.preferredChannel === 'Phone') ? handleCall(data) : handleConnect(data)} className="success-btn" style={{margin: "0 7px 0 0"}}>Launch</Button>}
                      </div>
                    : null }
                            {data?.status !== "cancelled" 
                                ?
                                    <>
                                    <div className="action-wrap" style={{ display: "flex", justifyContent: "space-around"}}>
                                        
                                        {data?.status === "proposed" ?
                                            data?.isFromWeb ?
                                                <span className="action-wrap" style={{ display: "flex", justifyContent: "space-around", margin: "0 15px 0 0" }}>Patient haven't accepted</span>
                                                : <>
                                                <span className="action-wrap" style={{ display: "flex", justifyContent: "space-around", marginTop: "0.15rem" }}>
                                                    <Button variant="primary" onClick={() => handleUpdateRequest(data, "booked")}
                                                        className="success-btn" startIcon={<Done style={{ color: "white" }} />} style={{ marginRight: "20px" }}>Accept</Button>
                                                    <Button variant="primary" onClick={() => handleUpdateRequest(data, "cancelled")}
                                                        className="delete-btn" startIcon={<Close style={{ color: "white" }} />}>Reject</Button>
                                                </span>
                                                </>
                                            : null}
                                        {(data?.status !== "completed" && data?.status !== "proposed") ?
                                            <Button  variant="primary" onClick={() => handleScheduleModal(data)} className="view-btn" style={{margin: "0 7px 0 0"}}>Reschedule</Button>
                                            : null}
                                        
                                    </div>
                                    {(data?.status === "booked" || (data?.status === "proposed" && data?.isFromWeb)) ?
                                    <div className="action-wrap" style={{ display: "flex", justifyContent: "space-around" }}>
                                    <Button variant="primary" onClick={() => handleCancelRequest(data)}
                                        className="delete-btn" style={{margin: "0"}}>Cancel Appointment</Button>
                                        <ConfirmationModal
                                            show={confirmmodalShow}
                                            onConfirm={handleConfirm}
                                            onCancel={handleCancel}
                                            data={data}
                                            message="Are you sure you want to cancel this appointment?"
                                        />
                                         </div>
                                    : null}
                                    </>
                                : null}
                       {/* </div> */} 
                   {/* : null }  */}
                    </div>
                    )}

                </Modal.Body>
            </Modal>
        </>
    );
}
